// EmptyState — friendly "nothing here yet" placeholder. Pattern from
// 00-design-system.html §08: large outlined icon, heading, body copy,
// optional CTA button.
//
// Use when a list is intentionally empty (no approvals pending, no tasks,
// etc.). For loading states use <Skeleton />. For error states use
// <ErrorState /> from this same package.

import type { ReactNode } from 'react';
import { Inbox } from 'lucide-react';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  body?: string;
  cta?: ReactNode;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  body,
  cta,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center rounded-xl border border-tcs-border bg-tcs-bg p-8 text-center ${className ?? ''}`}
    >
      <div className="text-tcs-text-muted">
        {icon ?? <Inbox className="h-12 w-12" strokeWidth={1.5} />}
      </div>
      <div className="mt-4 text-lg font-medium text-tcs-text-secondary">
        {title}
      </div>
      {body && (
        <div className="mt-1 max-w-md text-sm text-tcs-text-muted">{body}</div>
      )}
      {cta && <div className="mt-5">{cta}</div>}
    </div>
  );
}
